import auth from './auth'
import sales from './sales'
import settings from './settings'
import products from './products'
import purchase from './purchase'
import cart from './cart'
import account from './account'
import forms from './forms'
import stats from './stats'
export default [
  {
    path: '/',
    name: 'dashboard',
    meta: {
      authRequired: true
    },
    component: () => import('../views/dashboards/index')
  },

  ...auth,
  ...account,
  ...sales,
  //...settings,
  //...products,
  //...purchase,
  ...cart,
  //...forms,
  ...stats,
  {
    name: 'error404',
    path: '*',
    component: () => import('../views/error/page-not-found')
  }
]
